(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pw-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.dataset.pwFaqReady) return;
      root.dataset.pwFaqReady = 'true';

      var wrap = root.querySelector('[data-faq-search-wrap]');
      var input = root.querySelector('[data-faq-search]');
      if (!wrap || !input) return;

      var clear = root.querySelector('[data-faq-clear]');
      var status = root.querySelector('[data-faq-status]');
      var empty = root.querySelector('[data-faq-empty]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]')).map(function (el) {
        return { el: el, text: el.textContent.toLowerCase().replace(/\s+/g, ' ') };
      });

      /* The field only appears once the script that powers it is running */
      wrap.hidden = false;

      function apply() {
        var query = input.value.toLowerCase().trim();
        var terms = query ? query.split(/\s+/) : [];
        var visible = 0;

        items.forEach(function (item) {
          var match = terms.every(function (term) {
            return item.text.indexOf(term) !== -1;
          });
          item.el.hidden = !match;
          if (match) visible += 1;
        });

        groups.forEach(function (group) {
          var hasVisible = group.querySelector('[data-faq-item]:not([hidden])') !== null;
          group.hidden = !hasVisible;
          if (group.id) {
            var nav = root.querySelector('[data-faq-nav="' + group.id + '"]');
            if (nav) nav.hidden = !hasVisible;
          }
        });

        if (empty) empty.hidden = visible !== 0;
        if (clear) clear.hidden = query === '';
        if (status) {
          status.textContent = query === '' ? '' : visible === 1 ? '1 question found' : visible + ' questions found';
        }
      }

      input.addEventListener('input', apply);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && input.value !== '') {
          input.value = '';
          apply();
        }
      });
      if (clear) {
        clear.addEventListener('click', function () {
          input.value = '';
          apply();
          input.focus();
        });
      }
    }

    function initAll(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pw-faq]'), initFaq);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
